import { useTranslator } from '@Localization';
import { Button } from '@mui/joy';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { useAttachmentsService } from '../attachments.service';

export const AttachmentSelectAllContainer = observer((): ReactElement => {
  const attachmentsService = useAttachmentsService();
  const { t } = useTranslator();

  const onSelectAllAttachments = (): void => {
    const selectedAttachments = attachmentsService.store.selectedAttachments;
    selectedAttachments.isAllSelected = !selectedAttachments.isAllSelected;
    selectedAttachments.ids = [];
  };

  const isAllSelected = attachmentsService.store.selectedAttachments.isAllSelected;

  return (
    <Button
      variant={isAllSelected ? 'solid' : 'outlined'}
      onClick={onSelectAllAttachments}
    >
      {t(isAllSelected ? 'Deselect' : 'Select')}
    </Button>
  );
});
